export default "__VITE_ASSET__DxPNbAIR__"